import { AsarFormikInput } from "@/components/asarInput";
import { Loader } from "@/components/loader";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { inquiryPatient } from "../../../../api/area";
import questionMark from "../../../../assets/image/questionMark.png";
import MedicalRecordsIcon from "../../../../assets/SVG/medicalRecordsIcon";
import ParvandeIcon from "../../../../assets/SVG/parvandeIcon";
import FormReception from "./formReception";

export default function ReceptionPop({ onClose, areaId, ageType, onAdd }) {
  const [selectedLevel, setSelectedLevel] = useState();
  const [selectedMode, setSelectedMode] = useState("irani");
  const [DATA, setDATA] = useState();
  const [nationalId, setNationalId] = useState();
  const [levelPop, setLevelPop] = useState(0);

  const handleClose = () => {
    setDATA();
    setLevelPop(0);
    setNationalId();
    setSelectedLevel();
    onClose();
  };

  const validationSchema = Yup.object({
    nationalId: Yup.string()
      .required("کدملی/کد اتباع الزامی است")
      .min(10, "کدملی/کد اتباع باید حداقل 10 رقم باشد")
      .max(10, "کدملی/کد اتباع باید حداکثر 10 رقم باشد"),
  });

  return (
    <Grid
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      sx={{
        minWidth: "calc(min(100%, 500px))",
        maxWidth: "500px",
        margin: "0 auto",
      }}
    >
      {levelPop === 1 && !selectedLevel && (
        <Box
          height="470px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap="20px"
        >
          <Box
            display="grid"
            justifyItems={"center"}
            alignContent="center"
            gap="20px"
            borderRadius="15px"
            border="solid 3px #42C3CF "
            width="200px"
            height="190px"
            sx={{ cursor: "pointer" }}
            onClick={() => setSelectedLevel("issuing")}
          >
            <ParvandeIcon />
            <Typography color="#42C3CF">
              {DATA ? "صدور نوبت مجدد" : "صدور نوبت"}
            </Typography>
          </Box>
          {DATA && (
            <Box
              display="grid"
              justifyItems={"center"}
              alignContent="center"
              gap="20px"
              borderRadius="15px"
              border="solid 3px #42C3CF "
              width="50%"
              height="190px"
              sx={{ cursor: "pointer" }}
              onClick={() =>
                window.open(
                  `/parvandeh?areaId=${areaId}&patientIdentifier=${
                    DATA?.identifier
                  }&patientIdentifierType=${selectedMode === "irani" ? "NATIONAL_CODE" : "SRG"}&patientId=${
                    DATA?.id
                  }`,
                  "_blank",
                )
              }
            >
              <MedicalRecordsIcon />
              <Typography color="#42C3CF">{"مشاهده پرونده پزشکی"}</Typography>
            </Box>
          )}
        </Box>
      )}
      {selectedLevel && (
        <Box
          display="flex"
          width="100%"
          borderRadius={"9px"}
          bgcolor="var(--emr-background-color)"
          gap="5px"
          p="3px 5px"
          sx={{ cursor: "pointer" }}
        >
          {[
            { text: "ایرانی", mode: "irani" },
            { text: "اتباع", mode: "citizens" },
          ].map((x) => (
            <Typography
              onClick={() => setSelectedMode(x.mode)}
              p="3px"
              width="50%"
              textAlign="center"
              bgcolor={selectedMode === x.mode && "var(--emr-primary)"}
              borderRadius={"9px"}
              color={selectedMode === x.mode ? "white" : "#787878"}
              sx={{ transition: "0.3s all" }}
            >
              {x.text}
            </Typography>
          ))}
        </Box>
      )}
      {selectedLevel === "issuing" && levelPop !== 0 && (
        <FormReception
          DATA={DATA}
          nationalId={DATA ? undefined : nationalId}
          ageType={ageType}
          areaId={areaId}
          handleClose={handleClose}
          mode={selectedMode}
          setLevelPop={setLevelPop}
          setSelectedLevel={setSelectedLevel}
          onAdd={onAdd}
        />
      )}
      {levelPop === 0 && (
        <Formik
          initialValues={{ nationalId: "" }}
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          validateOnMount={false}
          onSubmit={async (values, actions) => {
            if (values.nationalId && areaId) {
              inquiryPatient(areaId, {
                identifier: values.nationalId,
                identifierType:
                  selectedMode === "irani" ? "NATIONAL_CODE" : "SRG",
              })
                .then((x) => {
                  if (x !== null) {
                    setDATA(x);
                    setLevelPop(1);
                  }
                  setNationalId(values.nationalId);
                  setSelectedLevel("issuing");
                })
                .catch(() => {
                  setLevelPop(1);
                })
                .finally(() => actions.setSubmitting(false));
            }
          }}
        >
          {({ isSubmitting, submitForm }) => (
            <Form style={{ width: "calc(min(100%, 400px))" }}>
              <Grid
                display="grid"
                gap="20px"
                justifyItems={"center"}
                alignContent="center"
              >
                <img src={questionMark} />
                <Typography color="#787878" fontWeight={"bold"}>
                  استعلام وضعیت پرونده بیمار
                </Typography>
                <AsarFormikInput
                  placeholder={
                    selectedMode === "irani"
                      ? "کد ملی بیمار را وارد کنید. "
                      : "کد اتباع بیمار را وارد کنید."
                  }
                  label="کدملی بیمار"
                  name={"nationalId"}
                  maxLength={10}
                  inputMode="numeric"
                />

                {isSubmitting && <Loader />}
                {!isSubmitting && (
                  <Grid
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"center"}
                    gap={"20px"}
                    width={"100%"}
                  >
                    <Button
                      variant="contained"
                      onClick={submitForm}
                      sx={{ width: "calc(min(50%, 200px))" }}
                    >
                      استعلام
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={handleClose}
                      sx={{ width: "calc(min(50%, 200px))" }}
                    >
                      انصراف
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Form>
          )}
        </Formik>
      )}
    </Grid>
  );
}
